module.exports = __webpack_public_path__ + "a48f0628540fa02fd1468f61ab821eb2.jpg";